// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimStatusDto
 */
export interface IClaimStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimStatusDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimStatusDto
     */
    claim_status_type?: IClaimStatusDtoClaimStatusTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimStatusDto
     */
    valid_to?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimStatusDtoClaimStatusTypeEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IClaimStatusDto interface.
 */
export function instanceOfIClaimStatusDto(value: object): value is IClaimStatusDto {
    return true;
}

export function IClaimStatusDtoFromJSON(json: any): IClaimStatusDto {
    return IClaimStatusDtoFromJSONTyped(json, false);
}

export function IClaimStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'claim_status_type': json['claim_status_type'] == null ? undefined : json['claim_status_type'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IClaimStatusDtoToJSON(json: any): IClaimStatusDto {
    return IClaimStatusDtoToJSONTyped(json, false);
}

export function IClaimStatusDtoToJSONTyped(value?: IClaimStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'claim_status_type': value['claim_status_type'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
    };
}

